import theme from '@vromo/ui/components/theme';
import { css } from 'emotion';

export const getPhotoStyles = (isSelected: boolean): string => css`
    cursor: pointer;
    max-width: 100px;
    height: auto;
    border-radius: 4px;
    margin: 10px 20px;
    opacity: ${isSelected ? 1 : 0.3};
    box-shadow: ${isSelected ? `0px 0px 0px 3px ${theme.primary}` : 'none'};
    transition: all 150ms ease-in-out;

    &:hover {
        opacity: 1;
    }
`;

export default {
    inspectorContainer: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 500px;
        padding: 20px;
        width: 30vw;
        border-left: 1px solid ${theme.lightGrey};

        @media (max-width: 1000px) {
            flex: 1;
            height: 300px;
            padding: 0px;
            width: 100%;
            border: none;
        }
    `,
    mainPhotoContainer: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        width: 100%;
    `,
    container: css`
        display: flex;

        @media (max-width: 1000px) {
            flex-direction: column-reverse;
        }
    `,
    photoExplorer: css`
        flex: 1;
    `,
    photoContainer: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        max-width: 600px;

        @media (max-width: 1000px) {
            flex-wrap: nowrap;
            overflow: scroll;
        }
    `,
    photo: css`
        max-height: 80%;
        max-width: 90%;
        width: auto;
        border-radius: 4px;
        margin: 10px 20px;
    `,
    buttonContainer: css`
        width: 100%;
        display: flex;
        justify-content: space-around;
    `,
    emptyContainer: css`
        height: 30vw;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
    buttonIcon: css`
        margin-right: 5px;
    `
};
